import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const Clock_lg = (props) => {
    const width = props.width ? props.width + 'px' : '32px';
    const height = props.height ? props.height + 'px' : '32px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 32 32"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 5C9.92487 5 5 9.92487 5 16C5 22.0751 9.92487 27 16 27C22.0751 27 27 22.0751 27 16C27 9.92487 22.0751 5 16 5ZM3 16C3 8.8203 8.8203 3 16 3C23.1797 3 29 8.8203 29 16C29 23.1797 23.1797 29 16 29C8.8203 29 3 23.1797 3 16ZM16 8C16.5523 8 17 8.44772 17 9V15.5L20.6 18.2C21.0418 18.5314 21.1314 19.1582 20.8 19.6C20.4686 20.0418 19.8418 20.1314 19.4 19.8L15.4 16.8C15.1482 16.6111 15 16.3148 15 16V9C15 8.44772 15.4477 8 16 8Z"
            />
        </SvgStyled>
    );
};

export default Clock_lg;
